import React from 'react';
import { SOURCES } from '../../site/sources';

// The short Sources list that closes any page quoting a stat.
export default function Sources({ ids }) {
  return (
    <section className="py-8 md:py-10 px-4 border-t border-slate-200">
      <div className="container mx-auto max-w-4xl">
        <p className="text-slate-400 text-[10px] md:text-xs uppercase tracking-[0.28em] mb-3">Sources</p>
        <ol className="space-y-1.5 text-xs md:text-sm text-slate-400">
          {ids.map((id) => {
            const s = SOURCES[id];
            return (
              <li key={id}>
                <a href={s.href} target="_blank" rel="noopener" className="hover:text-blue-600 transition-colors">{s.name}, {s.year}</a>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
